import React from 'react';

type TableEditorProps = {
	attributes: any;
	children?: any;
};

export const TableEditor = ({ attributes, children }: TableEditorProps) => {
	return (
		<table>
			<tbody {...attributes}>{children}</tbody>
		</table>
	);
};
